/**
 * À garder aligné avec `apps/api/src/modules/demo/services/demo-fixtures.ts`.
 * Après un reset démo (> phase 0), seul cet administrateur existe.
 */
export const DEMO_SEED_ADMIN_ALIAS = 'demo.admin';

export const DEMO_SEED_ADMIN_PASSWORD = 'demo-square-iso-2026';
